import { IIconProps } from '../../types/IconProps.interface'

export const IconMoneyWithdrawal = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 32 32'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M20 5C23.3137 5 26 7.68629 26 11C26 11.0431 25.997 11.086 25.9961 11.1289C27.7229 11.5717 29 13.135 29 15V27C29 29.0713 27.4256 30.774 25.4082 30.9785L25 31H7C4.9287 31 3.22601 29.4256 3.02148 27.4082L3 27V15C3 12.7909 4.79086 11 7 11H14C14 7.68629 16.6863 5 20 5ZM7 13C5.89543 13 5 13.8954 5 15V27C5 28.1046 5.89543 29 7 29H25C26.1046 29 27 28.1046 27 27V25H24C22.3431 25 21 23.6569 21 22V20C21 18.3431 22.3431 17 24 17H27V15C27 13.9646 26.2133 13.1124 25.2051 13.0098L25 13H7ZM24 19C23.4477 19 23 19.4477 23 20V22C23 22.5523 23.4477 23 24 23H27V19H24ZM20 7C17.7909 7 16 8.79086 16 11H24C24 8.79086 22.2091 7 20 7Z'
        fill={color}
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M10.5 0C12.9853 0 15 2.01472 15 4.5C15 6.98528 12.9853 9 10.5 9C8.01472 9 6 6.98528 6 4.5C6 2.01472 8.01472 0 10.5 0ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88071 9.11929 7 10.5 7C11.8807 7 13 5.88071 13 4.5C13 3.11929 11.8807 2 10.5 2Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  )
}
